export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_taxRates(state, {tax_rates}) {
    state.taxRates = tax_rates.data;
    state.totalCount = tax_rates.total;
    state.count = tax_rates.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
